/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_GroupInputs */

const en_user_group = /** @type {(inputs: User_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group`)
};

const ja_user_group = /** @type {(inputs: User_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループ`)
};

const fr_user_group = /** @type {(inputs: User_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe`)
};

const de_user_group = /** @type {(inputs: User_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe`)
};

/**
* | output |
* | --- |
* | "Group" |
*
* @param {User_GroupInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_group = /** @type {((inputs?: User_GroupInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_GroupInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_group(inputs)
	if (locale === "ja") return ja_user_group(inputs)
	if (locale === "fr") return fr_user_group(inputs)
	return de_user_group(inputs)
});